// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"20ddbd62","703":"41497a89"}[chunkId] + ".chunk.js";
};